module.exports = __webpack_public_path__ + "static/media/mr-lube.68c36aa8.svg";